/* eslint-disable consistent-return */
/* eslint-disable no-underscore-dangle */
import { Autocomplete, Chip, TextField, Tooltip } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { omsApi } from 'src/api/omsApis';
import axios from 'src/utils/axios';

const CustomAutoComplete = (props: any) => {
  const {
    id,
    value,
    onSelect,
    error,
    helperText,
    apiUrl,
    label,
    placeholder,
    disabled,
    args = {},
    isProducts,
    multiple,
  } = props;
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const searchData = async (searchText = '') => {
    setLoading(true);
    try {
      // let argument = "";
      // if (searchText.trim() !== "") {
      //     argument = `?search=${searchText}`
      // }

      const response = await axios.get(apiUrl, {
        params: {
          search: searchText,
          ...args,
        },
      });

      // omsApi.getOmsProductsAutoComplete(`${apiUrl}${argument}`);

      if (response.status === 204) {
        setLoading(false);
        setOptions([]);
      }

      if (response.status === 200) {
        setLoading(false);
        setOptions(response.data);
        return response.data;
      }
    } catch (failure) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!disabled) {
      searchData('');
    }
  }, [disabled, JSON.stringify(args)]);
  return (
    <>
      <Autocomplete
        id={id}
        options={options || []}
        value={value}
        disabled={disabled}
        multiple={multiple}
        getOptionLabel={(option) => {
          if (isProducts) {
            return option?.productTemplateObject?.Name;
          }
          return option?.name;
        }}
        onChange={(e: any, newValue: any) => {
          onSelect(e, newValue);
        }}
        renderTags={(tagValue, getTagProps) =>
          tagValue.map((option, index) => (
            <Tooltip title={option?.name || ''}>
              <Chip
                variant="filled"
                label={
                  index > 0 && option?.name?.length && option.name.length > 5
                    ? `${option.name.slice(0, 5)}...`
                    : option?.name || ''
                }
                size="small"
                {...getTagProps({ index })}
              />
            </Tooltip>
          ))
        }
        loading={loading}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder={placeholder}
            label={label}
            onChange={(event) => searchData(event.target.value)}
            error={error}
            helperText={helperText}
          />
        )}
      />
    </>
  );
};

export default CustomAutoComplete;
